import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import * as Toastr from 'toastr';
import 'toastr/build/toastr.min.css'

import * as authActions from '../actions/auth';
import './Login.css';

import CardSignIn from './../components/login/CardSignIn';
import CardSignUp from './../components/login/CardSignUp';
import CardCompletarCadastro from './../components/login/CardCompletarCadastro';
import LoginBanner from './../components/login/LoginBanner';

class Login extends Component {
  componentWillMount() {
    return !this.props.userIsAuthenticated && this.props.loadUserFromSession();
  }

  componentWillReceiveProps(nextProps) {
    const { userHasErrored, userIsAuthenticated, userResetPassword, location, clearResetSuccess } = nextProps;
    switch (true) {
      case userResetPassword:
        Toastr.success('E-mail de alteração de senha enviado!');
        clearResetSuccess();
        break;
      case this.autenticado(nextProps):
        nextProps.history.push('/marcadores');
        break;
      case !userIsAuthenticated && !!userHasErrored:
        clearTimeout(this.debouncer);
        this.debouncer = setTimeout(() => this.handleLoginError(), 500);
        break;
      case location.pathname === '/signup' || location.pathname === '/completar-cadastro':
        return nextProps;
      default:
    }
  }

  renderCard() {
    switch(this.props.location.pathname) {
      case '/completar-cadastro':
        return <CardCompletarCadastro onSubmit={ this.props.updateProfile } { ...this.props } />;
      case '/signup':
        return <CardSignUp { ...this.props } />
      default:
        return <CardSignIn { ...this.props } />
    }
  }

  render() {
    return (
      <div className="login">
        <div className="background"></div>
        <LoginBanner />
        <div className="action-pane">
          { this.renderCard() }
        </div>
      </div>
    );
  }

  handleLoginError() {
    const { userHasErrored, userIsAuthenticated, clearLoginError } = this.props;

    if (userHasErrored && !userIsAuthenticated) {
      //alert(userHasErrored);
      console.log(userHasErrored);
      switch(userHasErrored.error) {
        case 'auth/wrong-password':
        case 'auth/user-not-found':
        case 'auth/invalid-email':
          Toastr.error('Usuário ou senha inválidos');
          clearLoginError();
          break;
        case 'reset/auth/user-not-found':
          Toastr.error('Este e-mail não existe');
          clearLoginError();
          break;
        case 'auth/email-already-in-use':
          Toastr.error('Este e-mail já está sendo utilizado em outra conta');
          clearLoginError();
          break;
        case 'auth/popup-closed-by-user':
          clearLoginError();
          return false;
        default:
          Toastr.warning('Houve um problema. Contate o Administrador do sistema');
          clearLoginError();
      }
    }
  }

  autenticado(props) {
    return !props.userIsLoading && props.userIsAuthenticated;
  }

  cadastroCompleto(nextProps) {
    const user = nextProps.user;
    return !!user && !!user.nome && !!user.email && !!user.telefone;
  }
}

const mapStateToProps = (state) => {
  return {
    // params utilizados pelo redux form.
    enableReinitialize: true,
    initialValues: {
      nome: get(state.user, 'nome'),
      email: get(state.user, 'email'),
      telefone: get(state.user, 'telefone')
    },

    user: state.user,
    userHasErrored: state.userHasErrored,
    userIsAuthenticated: state.userIsAuthenticated,
    userIsLoading: state.userIsLoading,
    userResetPassword: state.userResetPassword,
  };
};
const mapDispatchToProps = (dispatch) => ( bindActionCreators(authActions, dispatch) );

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login.js